/*-----------------------------------------------------------------------------------
' Module Name:   tree.js
' Description:   does tree things
' Author:        Mike Harris
' Date:          5/12/16
'----------------------------------------------------------------------------------*/


$.fn.extend({
  treed: function (o) {

    var openedClass = 'globys-icon-tree-collapse';
    var closedClass = 'globys-icon-tree-expand';
    var preexpandLevels = Infinity;
    var searchEnabled = false;
    var searchShowChildren = false;
    var searchShowHighlightedMatch = false;
    var searchPlaceholderText = window.strings.SEARCHBOX_PLACEHOLDER_TEXT;
    var searchAlertText = window.strings.SEARCHBOX_ALERT_TEXT;
    var searchAriaLabel = window.strings.SEARCHBOX_ARIA_LABEL;
    var searchOnChange;
    var selectEnabled = false;
    var actionCallback;
    var expandAllEnabled = false;
    var expandAllText = window.strings.COMMON_EXPAND_ALL;
    var collapseAllText = window.strings.COMMON_COLLAPSE_ALL;
    var selectValueTarget;
    var dataAttribute;
    var selectPreselectValue;
    var searchLastFilterText;

    if (typeof o != 'undefined') {
      if (typeof o.openedClass != 'undefined') {
        openedClass = o.openedClass;
      }
      if (typeof o.closedClass != 'undefined') {
        closedClass = o.closedClass;
      }
      if (typeof o.preexpandLevels != 'undefined') {
        preexpandLevels = o.preexpandLevels;
      }
      if (typeof o.search != 'undefined') {
        if (typeof o.search != 'object') {
          searchEnabled = o.search;
        } else {
          if (typeof o.search.enable != 'undefined') {
            searchEnabled = o.search.enable;
          }
          if (typeof o.search.showChildren != 'undefined') {
            searchShowChildren = o.search.showChildren;
          }
          if (typeof o.search.showHighlightedMatch != 'undefined') {
            searchShowHighlightedMatch = o.search.showHighlightedMatch;
          }
          if (typeof o.search.placeholdertext != 'undefined') {
            searchPlaceholderText = o.search.placeholdertext;
          }
          if (typeof o.search.alertText != 'undefined'){
            searchAlertText = o.search.alertText;
          }
          if (typeof o.search.searchAriaLabel != 'undefined') {
            searchAriaLabel = o.search.searchAriaLabel;
          }
          if (typeof o.search.onchange != 'undefined') {
            searchOnChange = o.search.onchange;
          }
          if (typeof o.search.expandalltext != 'undefined') {
            expandAllText = o.search.expandalltext;
          }
          if (typeof o.search.collapsealltext != 'undefined') {
            collapseAllText = o.search.collapsealltext;
          }
        }
      }
      if (typeof o.expandAll != 'undefined') {
        expandAllEnabled = o.expandAll;
      }
      if (typeof o.select == 'object') {
        if (typeof o.select.enable != 'undefined') {
          selectEnabled = o.select.enable;
        }
        if (typeof o.select.valuetarget != 'undefined') {
          selectValueTarget = o.select.valuetarget;
        }
        if (typeof o.select.dataattribute != 'undefined') {
          dataAttribute = o.select.dataattribute;
        }
        if (typeof o.select.preselect != 'undefined') {
          selectPreselectValue = o.select.preselect;
        }
      }
      if (typeof o.actioncallback != 'undefined') {
        actionCallback = o.actioncallback;
      }
    }

    // initialize the tree DOM - add aria attributes, add expand/collapse icons as needed, set default branch expansion
    $(this).spin(spinOpts);
    var tree = $('ul:first', this);
    var treeLinks = [];
    var that = this;
    tree.attr('role', 'tree');
    tree.addClass("tree");
    tree.find('li').each(function () {
      var $branch = $(this); //li with children ul
      var $branchContents = $branch.children(':not(ul)')
      var $div = $('<div class=\'node-contents\'/>')
      if ($branch.has('ul').length) {
        $div.append("<span class='indicator indicator-expanded' type='button' aria-hidden='true' ><i class='globys-icon " + openedClass + "'></i></span>");
        $div.append("<span class='indicator indicator-collapsed' type='button' aria-hidden='true'><i class='globys-icon " + closedClass + "'></i></span>");
      }
      $branchContents.detach().appendTo($div)
      $branch.prepend($div)
      
      var isExpanded = ($branch.parents("ul").length <= preexpandLevels);
      $branch.addClass('branch');
      $branch.attr('aria-expanded', isExpanded);
    });
    tree.find('li ul').each(function() {
      var $subtree = $(this);
      $subtree.addClass('subtree');
    })
    tree.find('li.branch li:not(.branch), > li:not(.branch)').each(function () {
      var $leaf = $(this);
      $leaf.addClass('leaf');
    })

    // perform show/hide based on search box contents
    var doSearch = function (e) {
      const filterTextIsIncluded = function(item, loweCaseTextToFind) {
        if (!item) {
          return false;
        }
        const contentText = item.textContent || item.innerText || '';
        return contentText.toLowerCase().indexOf(loweCaseTextToFind) >= 0;
      }

      var filterText = $('.tree-search', that).val();
      const lowerCaseFilterText = filterText ? filterText.toLowerCase() : '';
      if ((searchLastFilterText || '').toLowerCase() === lowerCaseFilterText) {
        return;
      }
      $.spin(spinOpts);
      var $liColl = $('li', tree);
      if (!filterText) {
        // no search, remove display hiding
        $liColl.css('display', '');
      } else {
        $liColl.filter((_index, item)=> !filterTextIsIncluded(item, lowerCaseFilterText)).css('display', 'none');
        var $liMatches = $liColl.filter((_index, item)=> filterTextIsIncluded(item, lowerCaseFilterText));
        $liMatches.css('display', '');
        if (searchShowChildren) {
          $liMatches.children('.node-contents').filter((_index, item) => {
            return filterTextIsIncluded(item, lowerCaseFilterText);
          }).parent().find('li').css('display', '');
        }
        // reset indicators to new search visibility results
        $liMatches.attr('aria-expanded', true);
      }

      if (searchShowHighlightedMatch) {
        $('.node-contents', tree).unmark();
        $('.node-contents', tree).mark(filterText, { separateWordSearch:false });
      }

      setSearchAlert();
      $.spin(false);
      searchLastFilterText = filterText
      if (searchOnChange && typeof searchOnChange === 'function') { searchOnChange(); }
    }

    var setSearchAlert = function(){
      if (searchAlertText != null && searchAlertText != undefined){
        var searchStatusElem = tree.siblings("#searchStatus:first");
        if (searchStatusElem.is(":hidden")){
          searchStatusElem.show();
        }

        var totalItems =  $("li[role='treeitem']", tree).length
        var hiddenItems = $("li[role='treeitem'][style*='display: none']", tree).length;
        searchStatusElem.text(searchAlertText.replace("%d", totalItems - hiddenItems).replace("%n", totalItems));
    
      }
    }

    // prepend search box
    if (searchEnabled) {
      $(this).prepend('<div id="searchStatus" role="status" aria-live="polite" class="btn btn-sm btn-transparent btn-nolink"></div>')
    }

    // initialize expand-all/collapse-all controls
    if (expandAllEnabled) {
      $(this).prepend('<div class="tree-expand-controls action-bank"><button id="btnexpandAll" type="button" class="btn btn-default tree-expand-all telemetry-action" href="#">' + expandAllText + '</button><button id="btncollapseAll" type="button" class="btn btn-default tree-collapse-all telemetry-action" href="#">' + collapseAllText + '</button></div>');
      $('.tree-expand-all', this).on('click', function (e) {
        treeLinks.forEach(function(t) { t.expandAllItems() });
        if (searchEnabled) doSearch();
      })
      $('.tree-collapse-all', this).on('click', function (e) {
        treeLinks.forEach(function(t) { t.collapseAllItems() });
      })
    }

    // prepend search box
    if (searchEnabled) {
      var searchId = this.prop('id') + '-searchbox';
      $(this).prepend('<div class="tree-search-controls" role="search"><label for="' + searchId + '" class="form-label">' + searchPlaceholderText + '</label><input aria-label="' + searchAriaLabel + '" type="text" id="' + searchId + '"" class="tree-search form-control"></div>');
      $('.tree-search', this).on('keypress', function(e) { return !(e && e.keyCode == 13); }); // prevent Enter from refreshing page
      $('.tree-search', this).on('keyup', debounce(doSearch, 350));
    }

    var trees = $('[role="tree"]', this);
    for (var i = 0; i < trees.length; i++) {
      var treeLink = new TreeLinks(trees[i]);
      // initialize tree selection callback
      treeLink.selectCallback = !!selectEnabled ? function(e) {
        $('.list-item-selected', tree).removeClass('list-item-selected');
        $('[aria-selected=true]').removeAttr('aria-selected');
        var $li = $(e.target).parentsUntil('ul').last();
        if (!$li.length) $li = $(e.target);
        $li.addClass('list-item-selected');
        $li.attr({'aria-selected': true});
        if (selectValueTarget.length && $(selectValueTarget).length) {
          $(selectValueTarget).val($li.data(dataAttribute)).trigger('change');
        }
        if (actionCallback) { actionCallback(e); }
        return true;
      } : function(e) {
        if (actionCallback) { actionCallback(e); return true; }
        return false;
      };
      treeLink.init();
      treeLinks.push(treeLink);

      if (selectEnabled) {
        //set preselect value
        if (dataAttribute && dataAttribute.length > 0 && selectPreselectValue && selectPreselectValue.length > 0) {
          var itemFound = false;
          for(var idx = 0; (idx<treeLinks.length) && !itemFound; idx++) {
            var targetItem = treeLinks[idx].findItem(selectPreselectValue, function(a,b) {return $(a.domNode).data(dataAttribute).toString()===b;})
            if (targetItem) {
              itemFound = true;
              break;
            }
          }
          if (targetItem) {
            targetItem.tree.expandTreeitem(targetItem);
            targetItem.tree.expandAllSiblingItems(targetItem);
            $(targetItem.domNode).addClass('list-item-selected').attr('aria-selected', true);
          } else if (treeLinks.length) {
            // preselect value not found, so set to root node
            $(treeLinks[0].domNode).addClass('list-item-selected').attr('aria-selected', true);
          }
        } else if (treeLinks.length) {
          //No preselect value passed, select root node
          $(treeLinks[0].domNode).addClass('list-item-selected').attr('aria-selected', true);
        }
        $('.list-item-selected >.node-contents >:last', this).trigger('click');
      }
    }
    $(this).spin(false);
  }
});

// using treelinks example from WIA example page https://www.w3.org/TR/wai-aria-practices-1.1/examples/treeview/treeview-2/treeview-2a.html as starting point to make keyboard-accessible tree structure
var TreeLinks = function (node) {
  // Check whether node is a DOM element
  if (typeof node !== 'object') {
    return;
  }

  this.domNode = node;

  this.treeitems = [];
  this.firstChars = [];

  this.firstTreeitem = null;
  this.lastTreeitem = null;

  this.selectCallback = null;
};

TreeLinks.prototype.init = function () {

  function findTreeitems(node, tree, group) {

    var elem = node.firstElementChild;
    var ti = group;

    while (elem) {
      if ((elem.tagName.toLowerCase() === 'li' && ['span','div','button','a','mark'].includes(elem.firstElementChild.tagName.toLowerCase()))/* || elem.tagName.toLowerCase() === 'a'*/) {
        ti = new TreeitemLink(elem, tree, group);
        ti.init();
        tree.treeitems.push(ti);
        tree.firstChars.push(ti.label.substring(0, 1).toLowerCase());
      }

      if (elem.firstElementChild) {
        findTreeitems(elem, tree, ti);
      }

      elem = elem.nextElementSibling;
    }
  }

  // initialize pop up menus
  if (!this.domNode.getAttribute('role')) {
    this.domNode.setAttribute('role', 'tree');
  }

  findTreeitems(this.domNode, this, false);

  this.updateVisibleTreeitems();

  this.firstTreeitem.domNode.tabIndex = 0;
};

TreeLinks.prototype.findItem = function(matchValue, matcher) {
  if (!matcher) matcher=function(a,b) { return a===b; }
  for (var i = 0; i < this.treeitems.length; i++) {
    if (matcher(this.treeitems[i], matchValue)) {
      return this.treeitems[i];
    }
  }
}

TreeLinks.prototype.findContentItemsToFocus = function (treeitem) {
  return $(treeitem.domNode).children('.node-contents').find('.treeFocusItem').toArray();
};

TreeLinks.prototype.setFocusToContentItem = function (treeitem, contentItemNode) {
  this.setFocusToItem(treeitem, true);

  treeitem.domNode.tabIndex = -1;
  contentItemNode.tabIndex = 0;

  contentItemNode.focus();
};

TreeLinks.prototype.setFocusToItem = function (treeitem, suppressFocus) {
  for (var i = 0; i < this.treeitems.length; i++) {
    var ti = this.treeitems[i];

    if (ti === treeitem) {
      ti.domNode.tabIndex = 0;
      if (!suppressFocus) ti.domNode.focus();
    }
    else {
      ti.domNode.tabIndex = -1;
    }

    this.findContentItemsToFocus(ti).forEach(item => item.tabIndex = -1);
  }
};

TreeLinks.prototype.setFocusToNextItem = function (currentItem, includeFocusStops) {
  if (includeFocusStops) {
    const treeFocusItems = this.findContentItemsToFocus(currentItem);

    if (treeFocusItems.length > 0) {
      if (currentItem.domNode === document.activeElement) {
        this.setFocusToContentItem(currentItem, treeFocusItems[0]);
        return;
      }

      for (let index = 0; index <= treeFocusItems.length - 2; index++) {
        if (treeFocusItems[index] === document.activeElement) {
          this.setFocusToContentItem(currentItem, treeFocusItems[index + 1]);
          return;
        }
      }
    }
  }

  var nextItem = false;

  for (var i = (this.treeitems.length - 1); i >= 0; i--) {
    var ti = this.treeitems[i];
    if (ti === currentItem) {
      break;
    }
    if (ti.isVisible) {
      nextItem = ti;
    }
  }

  if (nextItem) {
    this.setFocusToItem(nextItem);
  }
};

TreeLinks.prototype.setFocusToPreviousItem = function (currentItem) {
  const treeFocusItems = this.findContentItemsToFocus(currentItem);

  if (treeFocusItems.length > 0) {
    if (treeFocusItems[0] === document.activeElement) {
      this.setFocusToItem(currentItem);
      return;
    }

    for (let index = treeFocusItems.length - 1; index > 0; index--) {
      if (treeFocusItems[index] === document.activeElement) {
        this.setFocusToContentItem(currentItem, treeFocusItems[index - 1]);
        return;
      }
    }
  }

  var prevItem = false;

  for (var i = 0; i < this.treeitems.length; i++) {
    var ti = this.treeitems[i];
    if (ti === currentItem) {
      break;
    }
    if (ti.isVisible) {
      prevItem = ti;
    }
  }

  if (prevItem) {
    const previousTreeFocusItems = this.findContentItemsToFocus(prevItem);

    if (previousTreeFocusItems.length > 0) {
      this.setFocusToContentItem(prevItem, previousTreeFocusItems[previousTreeFocusItems.length - 1]);
    } else {
      this.setFocusToItem(prevItem);
    }
  }
};

TreeLinks.prototype.setFocusToParentItem = function (currentItem) {
  if (currentItem.groupTreeitem) {
    this.setFocusToItem(currentItem.groupTreeitem);
  }
};

TreeLinks.prototype.setFocusToFirstItem = function () {
  this.setFocusToItem(this.firstTreeitem);
};

TreeLinks.prototype.setFocusToLastItem = function () {
  this.setFocusToItem(this.lastTreeitem);
};

TreeLinks.prototype.setAriaExpanded = function(ci, isExpanded) {
  ci.domNode.setAttribute('aria-expanded', isExpanded)
}

TreeLinks.prototype.expandTreeitem = function (currentItem) {
  if (!Array.isArray(currentItem)) currentItem = [currentItem];
  var that = this;
  currentItem.forEach(function(ci) {
    if (ci.isExpandable) {
      that.setAriaExpanded(ci, true);
    }
  })
  this.updateVisibleTreeitems();
};

TreeLinks.prototype.expandAllSiblingItems = function (currentItem) {
  for (var i = 0; i < this.treeitems.length; i++) {
    var ti = this.treeitems[i];

    if ((ti.groupTreeitem === currentItem.groupTreeitem) && ti.isExpandable) {
      this.expandTreeitem(ti);
    }
  }
};

TreeLinks.prototype.expandAllItems = function () {
  //for (var i = 0; i < this.treeitems.length; i++) {
  //  var ti = this.treeitems[i];
    this.expandTreeitem(this.treeitems);
  //}  
}

TreeLinks.prototype.collapseTreeitem = function (currentItem, suppressFocus) {
  if (!Array.isArray(currentItem)) currentItem = [currentItem];
  var focusItem = false;
  var that = this;
  currentItem.forEach(function(ci) {
    var groupTreeitem = false;

    if (ci.isExpanded()) {
      groupTreeitem = ci;
    } else {
      groupTreeitem = ci.groupTreeitem;
    }

    if (!focusItem) {
      focusItem = groupTreeitem;
    }
  
    if (groupTreeitem) {
      that.setAriaExpanded(groupTreeitem, false);
    }
  })

  this.updateVisibleTreeitems();
  this.setFocusToItem(focusItem, suppressFocus);
};

TreeLinks.prototype.collapseAllItems = function () {
  //for (var i = 0; i < this.treeitems.length; i++) {
  //  var ti = this.treeitems[i];
    this.collapseTreeitem(this.treeitems, true);
  //}  
}

TreeLinks.prototype.updateVisibleTreeitems = function () {
  this.firstTreeitem = this.treeitems[0];

  for (var i = 0; i < this.treeitems.length; i++) {
    var ti = this.treeitems[i];

    var parent = ti.domNode.parentNode;

    ti.isVisible = true;

    while (parent && (parent !== this.domNode)) {
      if ((parent.getAttribute('aria-expanded') || '').toLowerCase() == 'false') {
        ti.isVisible = false;
      }
      parent = parent.parentNode;
    }

    if (ti.isVisible) {
      this.lastTreeitem = ti;
    }
  }
};

TreeLinks.prototype.setFocusByFirstCharacter = function (currentItem, char) {
  var start, index, char = char.toLowerCase();

  // Get start index for search based on position of currentItem
  start = this.treeitems.indexOf(currentItem) + 1;
  if (start === this.treeitems.length) {
    start = 0;
  }

  // Check remaining slots in the menu
  index = this.getIndexFirstChars(start, char);

  // If not found in remaining slots, check from beginning
  if (index === -1) {
    index = this.getIndexFirstChars(0, char);
  }

  // If match was found...
  if (index > -1) {
    this.setFocusToItem(this.treeitems[index]);
  }
};

TreeLinks.prototype.getIndexFirstChars = function (startIndex, char) {
  for (var i = startIndex; i < this.firstChars.length; i++) {
    if (this.treeitems[i].isVisible) {
      if (char === this.firstChars[i]) {
        return i;
      }
    }
  }
  return -1;
};

var TreeitemLink = function (node, treeObj, group) {
  // Check whether node is a DOM element
  if (typeof node !== 'object') {
    return;
  }

  node.tabIndex = -1;
  this.tree = treeObj;
  this.groupTreeitem = group;
  this.domNode = node;
  this.label = node.innerText.split('\n')[0]; //node.textContent.trim();
  this.stopDefaultClick = false;

  if (node.getAttribute('aria-label')) {
    this.label = node.getAttribute('aria-label').trim();
  }

  this.isExpandable = false;
  this.isVisible = false;
  this.inGroup = false;

  if (group) {
    this.inGroup = true;
  }

  var elem = node.firstElementChild;

  while (elem) {
    if (elem.tagName.toLowerCase() == 'ul') {
      elem.setAttribute('role', 'group');
      this.isExpandable = true;
      break;
    }

    elem = elem.nextElementSibling;
  }

  this.keyCode = Object.freeze({
    RETURN: 13,
    SPACE: 32,
    PAGEUP: 33,
    PAGEDOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40
  });
};

TreeitemLink.prototype.init = function () {
  this.domNode.tabIndex = -1;

  if (!this.domNode.getAttribute('role')) {
    this.domNode.setAttribute('role', 'treeitem');
  }

  this.domNode.addEventListener('keydown', this.handleKeydown.bind(this));
  this.domNode.addEventListener('click', this.handleClick.bind(this));
  this.domNode.addEventListener('focus', this.handleFocus.bind(this));
  this.domNode.addEventListener('blur', this.handleBlur.bind(this));

  if (this.isExpandable) {
    this.domNode.firstElementChild.addEventListener('mouseover', this.handleMouseOver.bind(this));
    this.domNode.firstElementChild.addEventListener('mouseout', this.handleMouseOut.bind(this));
  }
  else {
    this.domNode.addEventListener('mouseover', this.handleMouseOver.bind(this));
    this.domNode.addEventListener('mouseout', this.handleMouseOut.bind(this));
  }
};

TreeitemLink.prototype.isExpanded = function () {
  if (this.isExpandable) {
    return this.domNode.getAttribute('aria-expanded') === 'true';
  }

  return false;
};

/* EVENT HANDLERS */

TreeitemLink.prototype.handleKeydown = function (event) {
  var tgt = event.currentTarget,
    flag = false,
    char = event.key,
    clickEvent;

  function isPrintableCharacter(str) {
    return str.length === 1 && str.match(/\S/);
  }

  function printableCharacter(item) {
    if (char == '*') {
      item.tree.expandAllSiblingItems(item);
      flag = true;
    }
    else {
      if (isPrintableCharacter(char)) {
        item.tree.setFocusByFirstCharacter(item, char);
        flag = true;
      }
    }
  }

  this.stopDefaultClick = false;

  if (event.cancelBubble || event.altKey || event.ctrlKey || event.metaKey) {
    return;
  }
  if (event.target !== this.domNode && !($(event.target).closest(this.domNode.tagName).is($(this.domNode)))) {
    return;
  }

  if (event.shift) {
    if (event.keyCode == this.keyCode.SPACE || event.keyCode == this.keyCode.RETURN) {
      event.stopPropagation();
      this.stopDefaultClick = true;
    }
    else {
      if (isPrintableCharacter(char)) {
        printableCharacter(this);
      }
    }
  }
  else {
    switch (event.keyCode) {
      case this.keyCode.SPACE:
      case this.keyCode.RETURN:
        var link = event.target.querySelector(':scope > .node-contents a.title[onclick]')

        if (link) {
          link.dispatchEvent(new Event('click'))
        }
        
        if (this.tree.selectCallback && typeof this.tree.selectCallback === 'function') {
          flag = this.tree.selectCallback(event);
          break;
        }

        if (this.isExpandable) {
          if (this.isExpanded()) {
            this.tree.collapseTreeitem(this);
          }
          else {
            this.tree.expandTreeitem(this);
          }
          flag = true;
        }
        else {
          event.stopPropagation();
          this.stopDefaultClick = true;
        }
        break;

      case this.keyCode.UP:
        this.tree.setFocusToPreviousItem(this);
        flag = true;
        break;

      case this.keyCode.DOWN:
        this.tree.setFocusToNextItem(this, true);
        flag = true;
        break;

      case this.keyCode.RIGHT:
        if (this.isExpandable) {
          if (this.isExpanded()) {
            this.tree.setFocusToNextItem(this, false);
          }
          else {
            this.tree.expandTreeitem(this);
          }
        }
        flag = true;
        break;

      case this.keyCode.LEFT:
        if (this.isExpandable && this.isExpanded()) {
          this.tree.collapseTreeitem(this);
          flag = true;
        }
        else  if (this.inGroup) {
          this.tree.setFocusToParentItem(this);
          flag = true;
        }
        break;

      case this.keyCode.HOME:
        this.tree.setFocusToFirstItem();
        flag = true;
        break;

      case this.keyCode.END:
        this.tree.setFocusToLastItem();
        flag = true;
        break;

      default:
        if (isPrintableCharacter(char)) {
          printableCharacter(this);
        }
        break;
    }
  }

  if (flag) {
    event.stopPropagation();
    event.preventDefault();
  }
};

TreeitemLink.prototype.handleClick = function (event) {
  // only process click events that directly happened on this treeitem
  if (event.cancelBubble || event.defaultPrevented) {
    return;
  }
  if (event.target !== this.domNode && !($(event.target).closest(this.domNode.tagName).is($(this.domNode)))) {
    return;
  }

  this.tree.setFocusToItem(this, event.detail<1);

  if (['a','button','span','mark'].includes(event.target.tagName.toLowerCase()) && !(Array.from(event.target.classList).includes('indicator')) && this.tree.selectCallback && typeof this.tree.selectCallback === 'function') {
    this.tree.selectCallback(event);
  } else if (this.isExpandable) {
    if (this.isExpanded()) {
      this.tree.collapseTreeitem(this);
    }
    else {
      this.tree.expandTreeitem(this);
    }
  }
  event.stopPropagation();
  event.preventDefault();
};

TreeitemLink.prototype.handleFocus = function (event) {
  var node = this.domNode;
  if (this.isExpandable) {
    node = node.firstElementChild;
  }
  node.classList.add('focus');
};

TreeitemLink.prototype.handleBlur = function (event) {
  var node = this.domNode;
  if (this.isExpandable) {
    node = node.firstElementChild;
  }
  node.classList.remove('focus');
};

TreeitemLink.prototype.handleMouseOver = function (event) {
  event.currentTarget.classList.add('hover');
};

TreeitemLink.prototype.handleMouseOut = function (event) {
  event.currentTarget.classList.remove('hover');
};